import { render } from "./SimpleDataCount.vue?vue&type=template&id=67c568f8&scoped=true"
import script from "./SimpleDataCount.vue?vue&type=script&lang=js"
export * from "./SimpleDataCount.vue?vue&type=script&lang=js"

import "./SimpleDataCount.vue?vue&type=style&index=0&id=67c568f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c568f8"],['__file',"src/components/h5/board/SimpleDataCount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67c568f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67c568f8', __exports__)) {
    api.reload('67c568f8', __exports__)
  }
  
  module.hot.accept("./SimpleDataCount.vue?vue&type=template&id=67c568f8&scoped=true", () => {
    api.rerender('67c568f8', render)
  })

}


export default __exports__